const
  NAME               = 'matchbind',
  VERSION            = '1.0.0',
  JQUERY_NO_CONFLICT = $.fn[NAME]
;

/**
 * This plugin add the behavior of resalt the player in the
 * local or visitor list when click on the field correspondign
 * position
 */
class Matchbind {
  constructor(element$) {
    this._element$ = element$;
    element$.find('.player').on('click mouseover', (e) => this.onClick(e));
  }

  onClick(e) {
    $('.team-members .member',        this._element$).removeClass('active');
    $('.voc-field-container .player', this._element$).removeClass('active');
    $('#' + $(e.target).data('related')).addClass('active');
    $(e.target).addClass('active');
  }

  static get VERSION() {
    return VERSION;
  }

  /**
   * This method is required to register the plugin as jQuery Plugin
   */
  static _jQueryInterface(/*config*/) {
    return this.each(function() {
      new Matchbind($(this));
    });
  }
}

$.fn[NAME]             = Matchbind._jQueryInterface;
$.fn[NAME].Constructor = Matchbind;
$.fn[NAME].noConflict  = function noConflict() {
  $.fn[NAME] = JQUERY_NO_CONFLICT;
  return Matchbind._jQueryInterface;
};

export default Matchbind;



// WEBPACK FOOTER //
// ./src/plugins/match-bind.js